export default __webpack_public_path__ + "static/media/img2.f429f457.jpg";